import {
  ArticleOutlined,
  AssessmentOutlined,
  DashboardOutlined,
  ListAltOutlined,
  PendingActionsOutlined,
  DatasetLinkedOutlined,
  TableViewOutlined,
} from "@mui/icons-material";
import { SidebarMenu, SidebarMenuItem } from "components/organisms/SideBar";
import { Paths, Permissions } from "configs";

interface SidebarMenuRoute extends SidebarMenu {
  children: Array<SidebarMenuItem & { permissions?: Array<string> | null }>;
}

export const SidebarMenuRoutes: Array<SidebarMenuRoute> = [
  {
    id: "G",
    name: "GENERAL",
    children: [
      {
        id: "G-Dashboard",
        label: "Dashboard",
        path: Paths.General.App,
        icon: DashboardOutlined,
        permissions: [Permissions.Dashboard.View],
      },
    ],
  },
  {
    id: "SCM",
    name: "SCHEMA MANAGEMENT",
    children: [
      {
        id: "SCM-SchemaList",
        label: "Schema List",
        path: Paths.SchemaManagement.Schemas,
        icon: ArticleOutlined,
        permissions: [
          Permissions.Schema.ViewList,
          Permissions.Schema.ViewDetail,
          Permissions.Schema.Create,
        ],
      },
      {
        id: "SCM-Dashboard",
        label: "Dashboard",
        tooltipTitle: "Schema Dashboard",
        path: Paths.SchemaManagement.SchemaDashboard,
        icon: DashboardOutlined,
        permissions: [Permissions.Schema.ViewDashboard],
      },
      {
        id: "SCM-ResultTable",
        label: "Result Table",
        tooltipTitle: "Schema Result Table",
        path: Paths.SchemaManagement.SchemaResults,
        icon: TableViewOutlined,
        permissions: [Permissions.Schema.ViewResultTable],
      },
    ],
  },
  {
    id: "SCD",
    name: "SCHEDULE MANAGEMENT",
    children: [
      {
        id: "SCD-ScheduleList",
        label: "Schedule List",
        path: Paths.ScheduleManagement.Schedules,
        icon: PendingActionsOutlined,
        permissions: [
          Permissions.Schedule.ViewList,
          Permissions.Schedule.ViewDetail,
          Permissions.Schedule.Create,
        ],
      },
      {
        id: "SCD-SurveyLinks",
        label: "Survey Links",
        path: Paths.ScheduleManagement.SurveyLinks,
        icon: DatasetLinkedOutlined,
        permissions: [Permissions.SurveyLink.ViewList],
      },
      {
        id: "SCD-Dashboard",
        label: "Dashboard",
        tooltipTitle: "Schedule Dashboard",
        path: Paths.ScheduleManagement.ScheduleDashboard,
        icon: DashboardOutlined,
        permissions: [Permissions.Schedule.ViewDashboard],
      },
      {
        id: "SCD-ResultTable",
        label: "Result Table",
        tooltipTitle: "Schedule Result Table",
        path: Paths.ScheduleManagement.ScheduleResults,
        icon: TableViewOutlined,
        permissions: [Permissions.Schedule.ViewResultTable],
      },
      {
        id: "SCD-ResultList",
        label: "Result List",
        path: Paths.ScheduleManagement.Results,
        icon: ListAltOutlined,
        permissions: [
          Permissions.Result.ViewList,
          Permissions.Result.ViewDetail,
        ],
      },
    ],
  },
  {
    id: "RP",
    name: "REPORT",
    children: [
      {
        id: "RP-CSAT",
        label: "CSAT",
        path: Paths.Report.CSAT,
        icon: AssessmentOutlined,
        permissions: [Permissions.CSAT.ViewList],
      },
      {
        id: "RP-CSAT-By-Object",
        label: "CSAT By Object",
        path: Paths.Report.CSATByObject,
        icon: AssessmentOutlined,
        permissions: [Permissions.CSAT.ViewList],
      },
      {
        id: "RP-CSAT-Corp",
        label: "CSAT Corp",
        path: Paths.Report.CSATCorp,
        icon: AssessmentOutlined,
        permissions: [Permissions.CSATCorp.ViewList],
      },
    ],
  },
];
